<template lang="html">
  <div id="presion" class="container-fluid">
    <div id="formulario-top">
      <div class="row">
        <div class="col-sm-2 col-sm-offset-3 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option2" @change="desdeEvent($event)"></date-picker>
          <br>
          <label for="desde" class="center-block" style="position: absolute; color: red;"> {{desdeText}}</label>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option" @change="hastaEvent($event)"></date-picker>
          <br>
          <label for="hasta" class="center-block" style="position: absolute; color: red;"> {{hastaText}}</label>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
            <select-c name="ducto" id="ducto" :options="ductos" placeholder="DUCTO" @changeSelect="setEstaciones($event)"></select-c>
        </div>
        <!-- <div id="check" class=" checkbox col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <label class="text-uppercase">
            <input id="auto-refresh" type="checkbox" value="true">auto-refrescar</label>
        </div> -->
      </div>
      <br>
      <br>
      <div class="row">
    <!--     <div class="col-sm-2 col-sm-offset-3 col-xs-8 col-xs-offset-2">
          <select-c name="estaciones" id="estaciones" :options="estaciones" placeholder="ESTACIONES"></select-c>
        </div> -->
        <div id="" class="col-sm-2 col-sm-offset-3 col-xs-8 col-xs-offset-2">
          <button id="buscar-btn" class="btn btn-default waves-effect waves-light" @click="GET_DIRECTION_TRENDS()" :class="[(desde === '' || ductos === [] || validation === false) ? 'disabled': '']">
            Buscar
          </button>
        </div>
        <div id="" class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2" v-if="showNewWindow">
          <router-link tag="a" :to="`/barchart/${desde}/${hasta}/${ducto}/${estacion || -1}`" target="_blank" id="new-window" class="btn btn-default waves-effect waves-light">
            Abrir en nueva ventana
          </router-link>
        </div>
      </div>

    </div>
    <div id="graficas" class="row">
      <div id="line-chart">
        <!-- <bar-chart :height="300" ref="chart" :chartData="datacollection" :options="chartOps"></bar-chart> -->

          <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-4">
              <center><h5 style="color:#0d6768;padding-bottom:30px">Eventos por Tramo</h5></center>
               <pie-chart-duct :chartData="DuctDatac" :width="300"  :height="250"></pie-chart-duct>
            </div>
            <div class="col-sm-4">
              <center><h5 style="color:#0d6768;padding-bottom:30px">Eventos por Municipio</h5></center>
              <pie-chart-city :chartData="CityDatac" :width="300" :height="250"></pie-chart-city>
            </div>
             <div class="col-sm-2"></div>
          </div>
           <div class="row container1">
            <div class="col">
               <center><h5 style="color:#0d6768;padding-bottom:50px">Eventos por Kilometraje</h5></center>
            <bar-chart :chartData="KMsDatac" :options="chartOps" :width="1000" :height="400"></bar-chart>
            </div>
          </div>

      </div>
    </div>

    <div id="graficas" class="row" style="padding-top:10px;">

    </div>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"> Iniciar sesión</button>
    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>

<script>
  let Modal = () => import('reusable/Modal')
  let LoadingModal = () => import('components/Modals/LoginModal')
  import selectC from 'components/reusable/Select'
  import BarChart from 'components/Charts/BarChart_KM.js'
  import PieChartCity from 'components/Charts/PieChart_City.js'
   import PieChartDuct from 'components/Charts/PieChart_Ducts.js'
  import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  import toastr from 'toastr'
  import axios from '../../common/axios';
 // var _ = require('lodash')

  export default {
    'bar-chart': BarChart,
    'pie-chart-city': PieChartCity,
    'pie-chart-duct': PieChartDuct,
    data() {
      return {
        modalName: 'loading-modal',
        info: {
          modalName: this.modalName
        },
        initial_loading: false,
        pieChartOps: {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
        },
        chartOps: {
         scales: {
                yAxes: [{
                  ticks: {
                    beginAtZero: true
                  },
                  gridLines: {
                    display: true
                  }
                }],
                xAxes: [ {
                  gridLines: {
                    display: false
                  }
                }]
              },
              legend: {
                display: false
              },
              ticks: {
            stepSize: 1,
            min: 0,
            autoSkip: false
           },
        },
        date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsHasta,
        option2: this.$store.state.dpOpsDesde,
        desde: '',
        hasta: '',
        tipo: 'FILTER_DATA',
        click: false,
        hastaEmpty: true,
        presion: null,
        pollTimer: null,
        datacollection: null,
        CityDatac: null,
        DuctDatac: null,
        KMsDatac: null,
        chartOptions: null,
        preasure: [],
        opDuctos: [],
        ductos: [],
        ducto: null,
        estaciones: [],
        estacion: null,
        opEstaciones: [],
        fechas: [],
        newestGpsTimestamp: -1,
        maxChart: 0,
        desdeText: '',
        hastaText: '',
        validation: false,
        showNewWindow: false,
        data_response: [],
        data_by_duct: [],
        data_by_city: [],
        data_by_km: [],
        data_by_duct_data: [],
        data_by_duct_label: [],
        data_by_city_data: [],
        data_by_city_label: [],
        data_by_km_data: [],
        data_by_km_label: [],
        direction_trends_object: []
      }
    },
    computed: {

    },
    methods: {
      DIVIDE_KM_ARRAY () {
        var kms = this.data_by_km
        let datasets = []
        let colorlist = [
          '#e74c3c',
          '#28b463',
          '#5dade2',
          '#f4d03f',
          '#FFFFFF',
          '#884ea0',
          '#e67e22',
          '#6c3483',
          '#f1948a',
          '#45b39d',
          '#76d7c4',
          '#c0392b',
          '#d7bde2',
          '#2e86c1',
          '#117a65',
          '#d35400',
          '#239b56',
          '#47145c',
          '#808080',
          '#800080',
          '#3366ff',
          '#800000',
          '#99cc00',
          '#666699',
          '#333300',
          '#9F609C',
          '#E4D183',
          '#0F3057',
          '#404B69',
          '#333333'
        ]
        for (let i = 0; i < kms.length; i++) {
          this.data_by_km_data[i] = kms[i].data
          this.data_by_km_label[i] = kms[i].label
        }
        datasets.push({
          label: 'ALERTAS CADA 10 KM',
          data: this.data_by_km_data,
          fill: true,
          backgroundColor: colorlist,
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 0
        })
        this.KMsDatac = Object.assign({}, this.datasets, {labels: this.data_by_km_label, datasets: datasets})
      },
      DIVIDE_DUCT_ARRAY () {
        let datasets = []
        let colorlist = [
          '#e74c3c',
          '#28b463',
          '#5dade2',
          '#f4d03f',
          '#FFFFFF',
          '#884ea0',
          '#e67e22',
          '#6c3483',
          '#f1948a',
          '#45b39d',
          '#76d7c4',
          '#c0392b',
          '#d7bde2',
          '#2e86c1',
          '#117a65',
          '#d35400',
          '#239b56',
          '#47145c',
          '#808080',
          '#800080',
          '#3366ff',
          '#800000',
          '#99cc00',
          '#666699',
          '#333300',
          '#9F609C',
          '#E4D183',
          '#0F3057',
          '#404B69',
          '#333333'
        ]
        var duct = this.data_by_duct
        for (let i = 0; i < duct.length; i++) {
          this.data_by_duct_data[i] = duct[i].data
          this.data_by_duct_label[i] = duct[i].label
        }
        datasets.push({
          label: this.data_by_duct_label,
          data: this.data_by_duct_data,
          fill: false,
          backgroundColor: colorlist,
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 0
        })
        this.DuctDatac = Object.assign({}, this.datasets, {labels: this.data_by_duct_label, datasets: datasets})
      },
      DIVIDE_CITY_ARRAY () {
        let datasets = []
        let colorlist = [
          '#e74c3c',
          '#28b463',
          '#5dade2',
          '#f4d03f',
          '#FFFFFF',
          '#884ea0',
          '#e67e22',
          '#6c3483',
          '#f1948a',
          '#45b39d',
          '#76d7c4',
          '#c0392b',
          '#d7bde2',
          '#2e86c1',
          '#117a65',
          '#d35400',
          '#239b56',
          '#47145c',
          '#808080'
        ]
        var city = this.data_by_city
        for (let i = 0; i < city.length; i++) {
          this.data_by_city_data[i] = city[i].data
          this.data_by_city_label[i] = city[i].label
        }
        datasets.push({
          label: this.data_by_city_label,
          data: this.data_by_city_data,
          fill: false,
          backgroundColor: colorlist,
          pointBorderWidth: 1,
          borderWidth: 1,
          pointRadius: 0
        })
        this.CityDatac = Object.assign({}, this.datasets, {labels: this.data_by_city_label, datasets: datasets})
      },
      GET_DIRECTION_TRENDS() {
        if (document.querySelector('#buscar-btn').classList.contains('disabled')) {
          return
        }
        this.showNewWindow = true
        this.maxChart = 0

        this.click = true
        this.loading()
        this.ducto = document.querySelector('#ducto').value
        var splitfrom = this.desde.split(' ')
        var splitto = this.hasta.split(' ')
        var from = splitfrom[0]
        var to = splitto[0]
        return new Promise((resolve, reject) => {
          this.loading()
          axios.get(process.env.API_BASE_URL + `direction/trends?id_section=${this.ducto}&dateFrom=${from}&dateTo=${to}`)
          .then(response => {
            this.data_by_duct = response.data.data[0]
            this.data_by_city = response.data.data[1]
            this.data_by_km = response.data.data[2]

            return resolve(this.DIVIDE_CITY_ARRAY(),
              this.DIVIDE_KM_ARRAY(),
              this.DIVIDE_DUCT_ARRAY()
            );
          })
          .catch(err => {
            return reject(err)
          })
        })
      },
      hastaEvent(e) {
        this.hasta = e
        this.hastaEmpty = false
        this.validate()
      },
      desdeEvent(e){
        this.desde = e
        this.validate()
      },
      validate() {
        let max = this.hasta
        let min = this.desde
        if(max !== '' && (max <= min || min === '')) {
          this.desdeText = 'Este valor debe ser menor'
          this.hastaText = 'Este valor debe ser mayor'
          this.validation = false
        } else {
          this.desdeText = ''
          this.hastaText = ''
          this.validation = true
        }
      },
      formatDate(date = '') {
        if (date === '') {
          date = new Date().toLocaleString('es-US', {
            hour12: false
          }).split(' ')
        }

        let time = date[1]
        let mdy = date[0].split('/')
        let month = parseInt(mdy[0])
        let day = parseInt(mdy[1])
        let year = parseInt(mdy[2])
        return `${year}-${day}-${month} ${time}`
      },
      filterData() {
        if (document.querySelector('#buscar-btn').classList.contains('disabled')) {
          return
        }
        this.showNewWindow = true
        this.maxChart = 0

        this.click = true
        this.loading()

        this.desde = this.desde || new Date().getTime() - 86400000
        this.hasta = this.hasta || null
        this.estacion = document.querySelector('#estaciones').value
        this.ducto = document.querySelector('#ducto').value
        this.$store
          .dispatch('LOAD_STATISTICS', {
            lastTimestamp: -1,
            ducto: this.ducto,
            estacion: (this.estacion === 'TODAS' || this.estacion === '') ? '' : this.estacion,
            desde: this.desde,
            hasta: this.hasta
          })
          .then((resp) => {
            if(resp === 'same-data' && this.click) {
              toastr.warning('Información repetida')
              this.loading()
            } else if(resp === 'no-data' && this.click) {
              toastr.error('No se encontró información')
              this.loading()
            }

            this.fill()
          })
          .catch(err => {
            console.log(err)
          })
      },
      GET_DATA(data, filter = false) {
        return this.$store.getters.GET_PRESION_SPECIFIC_DATA(data)
      },
      updateInfo(label, data) {
        let section = Object.keys(data)[0]
        let labels = Object.keys(data[section])
        let datasets = []
        let colors = [
          '#e74c3c ',
          '#28b463 ',
          '#5dade2 ',
          '#f4d03f ',
          '#ffffff ',
          '#b400ff ',
          '#e67e22 ',
          '#6c3483 ',
          '#f1948a ',
          '#45b39d ',
          '#76d7c4 ',
          '#c0392b ',
          '#d7bde2 ',
          '#2e86c1 ',
          '#117a65 ',
          '#d35400 ',
          '#239b56 ',
        ]
        let index = 0
        let didUpdate = false
        labels.forEach(station => {
          data[section][station].pressure.filter(yValue => {
            if(yValue.y >= this.maxChart) {
              this.maxChart = yValue.y
              didUpdate = true
            }
          })
        })
        if(didUpdate) {
          this.maxChart = Math.ceil(this.maxChart / 5) * 5
        }

        if (!this.datacollection || this.click) {
          labels.forEach(station => {
            datasets.push({
              label: station,
              data: data[section][station].pressure,
              fill: false,
              backgroundColor: colors[index],
              borderColor: colors[index],
              pointBorderWidth: 1,
              borderWidth: 1,
              pointRadius: 1
            })
            index = index + 1
          })
          this.datacollection = {
            datasets: datasets
          }
          //
          this.chartOps.scales.xAxes[0].time.min = this.desde
          this.chartOps.scales.xAxes[0].time.max = this.hasta
        }

        if (!this.click && this.hastaEmpty) {
          for (let idx in this.datacollection.datasets) {
            let _dataSet = this.datacollection.datasets[idx]
            let _station = _dataSet.label
            let _data = _dataSet.data
            if (
              data[section] &&
              data[section][_station] &&
              data[section][_station].pressure
            ) {
              this.datacollection.datasets[idx].data = data[section][_station].pressure.concat(_data)
              let unixtime = Date.parse(data.newest_data)
              this.chartOps.scales.xAxes[0].time.max = unixtime
            }
          }
        }

        let max = this.hasta || new Date()
        let min = this.desde
        var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime())
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
        if(diffDays > 2) {
          this.chartOps.scales.xAxes[0].time.unit = 'day'
          this.chartOps.scales.xAxes[0].time.stepSize = 1
        } else {
          this.chartOps.scales.xAxes[0].time.unit = 'hour'
          this.chartOps.scales.xAxes[0].time.stepSize = 3
        }

        this.chartOps.scales.yAxes[0].ticks.max = this.maxChart

        this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10

        this.$refs.chart._chart.update(0)
      },
      setEstaciones(e) {
        this.estaciones = this.$store.getters.GET_OP({
          filteredBy: 'sites',
          ducto: document.querySelector(`#${e}`).value
        })
        this.estaciones.push('TODAS')
      },
      fill() {
        let state = this.$store.state
        if (state.cached_presion === null) {
          this.pollTimer = setTimeout(() => {
            this.pollData(-1)
          }, 500)
          return
        }

        if (state.fill) {
          this.initial_loading = true
          this.presion = this.$store.state.cached_presion
          let data = {}
          let timestamps = {}
          let newestData = null
          if (this.presion.length > 0 || !this.click) {
            this.presion.forEach(event => {
              if (!data[event['section_name']]) {
                data[event['section_name']] = {}
              }
              if (!data[event['section_name']][event['rtu_name']]) {
                data[event['section_name']][event['rtu_name']] = {}
                data[event['section_name']][event['rtu_name']].pressure = []
              }
              data[event['section_name']][event['rtu_name']].pressure.push({
                y: event.pressure,
                x: event.formated_date
              })
              timestamps[event['formated_date']] = event['formated_date']
              if (!newestData || newestData < event['formated_date']) {
                newestData = event['formated_date']
              }
              if (this.newestGpsTimestamp < event['gps_timestamp']) {
                this.newestGpsTimestamp = event['gps_timestamp']
              }
            })
            data['newest_data'] = newestData
            this.updateInfo(document.querySelector('#ducto').value, data)

            if (this.click) {
              this.loading()
            }

            this.click = false
          }
        }

        this.pollTimer = setTimeout(() => {
          this.pollData(this.newestGpsTimestamp)
        }, 1000 * 10 * 1)
      },
      loading() {
        document.querySelector('#loading-btn').click()
      },
      pollData(gpsTimestamp) {
        if(this.hastaEmpty) {
          this.click = false
          let estaciones = document.querySelector('#estaciones').value
          this.$store.dispatch('LOAD_PRESION', {
            lastTimestamp: gpsTimestamp,
            ducto: document.querySelector('#ducto').value,
            estacion: (estaciones === 'TODAS' || estaciones === '') ? '' : estaciones,
            desde: this.desde,
            hasta: null
          })
          .then((resp) => {
            if(resp === 'no-data' && this.click) {
              toastr.error('No se encontró información')
            }
            if (this.hastaEmpty && this.initial_loading && !this.click) {
              this.fill()
            }
          })
          .catch(err => {
            console.log(err)
            this.pollTimer = setTimeout(() => {
              this.pollData(gpsTimestamp)
            }, 1000 * 60 * 1)
          })
        }
      }
    },
    mounted() {
      this.$store.dispatch('LOAD_OPS')
        .then(resp => {
          this.ductos = this.$store.getters.GET_OP({
            filteredBy: 'section_name'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    beforeDestroy() {
      clearTimeout(this.pollTimer)
    },
    components: {
      selectC,
      BarChart,
      PieChartCity,
      PieChartDuct,
      datePicker,
      Modal,
      LoadingModal
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  .container-fluid {
    margin: 0;
    padding: 0;
  }

  #presion {
    background-color: $bg;
    min-height: 100vh;
    #formulario-top {
      height: 25vh;
      margin-top: 80px;
      border-bottom: 1px solid $inactive;
    }

    #graficas {
      background-color: #d3d3d3;
      height: 100%;
      width: 100%;
      margin: 0;
      padding: 0;
    }

    .btn-default {
      margin-top: 0;
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
      @include celphone {
        margin-top: 50px;
      }
    }
  }

  #line-chart {
    width: 80vw;
    margin: 50px auto;
  }
  #pie-chart {
    height: auto;
    margin: 50px auto;
  }
  .container1 {
  padding-top:100px;
  max-width: 100%;
  margin:  0 auto;
}
  .container2 {
  max-width: 400px;
  margin:  0 auto;
}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Tendencias.vue?d581330c